import GeoJSON from 'ol/format/GeoJSON'

import {splitToPolygons} from '@helpers/openlayers/features'

export const geoJsonFormat = new GeoJSON({dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857'})

export const splitToPolygonsAsGeoJson = featureOrFeatures => {
  return JSON.parse(geoJsonFormat.writeFeatures(splitToPolygons(featureOrFeatures)))
}
